import { render, staticRenderFns } from "./FooterStoreInfo.vue?vue&type=template&id=695d96a8&"
import script from "./FooterStoreInfo.vue?vue&type=script&lang=js&"
export * from "./FooterStoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports